import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { useLanguage } from '../../../../../context/language/language';
import useResponsive from '../../../../../utils/responsive';

const useStyles = makeStyles((theme) => ({
  root: {},
  text: {
    '& .MuiFilledInput-root': {
      background: '#FFFFFF',
      border: '1px solid #E0E0E0',
      boxSizing: 'border-box',
      borderRadius: '8px',
    },
    '& .MuiFormLabel-root': {
      color: '#A3A3A3',
    },
    '& .MuiFilledInput-underline:before': {
      content: 'none',
    },
    '& .MuiFilledInput-underline:after': {
      content: 'none',
    },
    '& .MuiFilledInput-input': {
      fontWeight: 'bold',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      // opacity: 1;
      background: '#F3F3F3',
      /* border: 1px solid #E0E0E0; */
      /* box-sizing: border-box; */
      borderRadius: '8px',
    },
  },
}));

const MalaysiaAddressForm = ({
  onAddressNumberChange,
  disable,
  disablePostalCode,
  disableCity,
  addressNumber,
  mySubDistrict,
  myCity,
  myState,
  postalCode,
  disableState
}) => {
  const classes = useStyles();
  const word = useLanguage();
  const { isMobile } = useResponsive();
  return (
    <Grid container spacing={isMobile ? 1 : 2}>
      <Grid item xs={12}>
        <TextField
          style={{ width: '100%' }}
          className={classes.text}
          label={word('Address.Number')}
          variant="filled"
          value={addressNumber || ''}
          name="addressNumber"
          onChange={onAddressNumberChange}
          inputProps={{ maxLength: 50 }}
          id="address-number"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          style={{ width: '100%' }}
          className={classes.text}
          label={word('Address.Street')}
          variant="filled"
          name="mySubDistrict"
          value={mySubDistrict || ''}
          onChange={onAddressNumberChange}
          id="address-street"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          style={{ width: '100%' }}
          className={classes.text}
          label={word('Address.District')}
          variant="filled"
          value={myCity || ''}
          disabled={disableCity}
          onChange={onAddressNumberChange}
          name="myDistrict"
          id="address-district"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          style={{ width: '100%' }}
          className={classes.text}
          label={word('Address.Province')}
          variant="filled"
          value={myState || ''}
          disabled={disableState}
          onChange={onAddressNumberChange}
          name="myProvince"
          id="address-province"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          style={{ width: '100%' }}
          className={classes.text}
          label={word('Address.Postal')}
          variant="filled"
          value={postalCode || ''}
          disabled={disablePostalCode}
          onChange={onAddressNumberChange}
          name="postalCode"
          id="address-postal"
        />
      </Grid>
    </Grid>
  );
};

export default MalaysiaAddressForm;
